import Notification from "../../components/shared/Notification";
import request from "../../helpers/request";

export const getAllNotification = async () => {
  try {
    let token = localStorage.getItem("token");
    return await request(token)
      .get(`/v2/notification/all`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              data?.error ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getNotExpiredNotification = async () => {
  try {
    let token = localStorage.getItem("token");
    return await request(token)
      .get(`/v2/notification`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              data?.error ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const createNotification = async (data) => {
  try {
    let token = localStorage.getItem("token");
    return await request(token)
      .post(`/v2/notification/create`, data)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              data?.error ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        Notification("Successfully created notification!", "", "success");

        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const updateNotification = async (notificationId, data) => {
  try {
    let token = localStorage.getItem("token");
    return await request(token)
      .put(`/v2/notification/${notificationId}/update`, data)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              data?.error ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        Notification("Successfully updated notification!", "", "success");
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const deleteNotification = async (notificationId) => {
  try {
    let token = localStorage.getItem("token");
    return await request(token)
      .delete(`/v2/notification/${notificationId}`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              data?.error ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        Notification("Successfully deleted notification!", "", "success");
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};
